import { Black, BorderGrey } from './Colors';

export default {
  fontSize: '12px',
  fontColor: Black,
  borderRadius: '5px',
  borderWidth: '1px',
  borderColor: BorderGrey,
  padding: '5px',
  backgroundColor: 'transparent'
};
